const AppConfig = {
    languages : [
        'en', 'de'
    ],
    defaultLanguage : 'en'
};

export {AppConfig};
